// extracted by mini-css-extract-plugin
export var subtitle = "_be-2";
export var title = "_be-0";
export var titleNoWrap = "_be-1";